
import { useState, useCallback } from 'react';
import { CertificateView } from './CertificateView';
import { CertificateList } from './CertificateList';



export const UserCertificate = () => {
    const [appleCertificate, setAppleCertificate] = useState(null);

    
    const onToggleCertificate = useCallback((certificate) => {
        if (appleCertificate === certificate) {
            setAppleCertificate(null);
        } else {
            setAppleCertificate(certificate);
        }
    }, [appleCertificate]);

    return (
        <>
            <div className="col6 box print certificate">
                <div className="inner">
                    <h3><span className="icon07">독서길라잡이 상장 출력</span><i className="icon print fas fa-print"></i></h3>
                    <div className="certificate_area">
                        <CertificateList appleCertificate={appleCertificate} onToggleCertificate={onToggleCertificate} />
                    </div>
                </div>
            </div>
            {appleCertificate && <CertificateView appleCertificate={appleCertificate} />}
        </>
    );

};